import React from 'react';
import imageSources from '../../../constants/imageSources/imageSources';
import * as Styled from './styles';

const WebAppOnly = () => (
    <Styled.StaffbaseSettings>
        <div style={{ textAlign: 'center', marginTop: 25, marginBottom: 12 }}>
            <img src={imageSources.SBT_LOGO} alt="" width="90" />
        </div>
        <Styled.TitleText>Available on the Web App</Styled.TitleText>
        <Styled.Text>
            You can only access your Published News List on{' '}
            <Styled.InstructionsLink href="http://app.bananatag.com" target="_blank" rel="noopener noreferrer">
                app.bananatag.com
            </Styled.InstructionsLink>
            .
        </Styled.Text>
    </Styled.StaffbaseSettings>
);

export default WebAppOnly;
